import { render } from "./FacebookButtons.vue?vue&type=template&id=171324be&scoped=true"
import script from "./FacebookButtons.vue?vue&type=script&lang=ts"
export * from "./FacebookButtons.vue?vue&type=script&lang=ts"

import "./FacebookButtons.vue?vue&type=style&index=0&id=171324be&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-171324be"

export default script